export class VarCall {
    constructor(identifier, listaNodos, flwor, linea, columna) {
        this.linea = linea;
        this.columna = columna;
        this.identifier = identifier;
        this.listaNodos = listaNodos;
        this.flwor = flwor;
    }
    ejecutar(ent) {
    }
}
